import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { ActivityFilter, ActivityResponse } from '@core/models/activity.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ActivityService {
  constructor(private readonly apiService: ApiService) {}

  getActivities(filter: ActivityFilter): Observable<ActivityResponse> {
    return this.apiService.get<ActivityResponse>('/generic/activity', filter as any);
  }
}
